import React from 'react';
import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay';
import { SbRespTradeSourcingBannerLazy } from './SbRespTradeSourcingBannerLazy';
import get from 'lodash.get';
import { getSourcingRequestSubmitted } from 'dibs-trade-sourcing/exports/storageHelper';
import { pageTypeConstants } from '../../constants/pageTypeConstants';
import { VERTICALS } from '../../constants/uriConstants';

const { SEARCH } = pageTypeConstants;
const validCategories = [VERTICALS.ART, VERTICALS.FURNITURE];

export function SbRespTradeSourcingBannerComponent({ searchBrowse, user }) {
    const topCategoryL1 = get(searchBrowse, 'topCategoryL1');
    const isValidCategory = validCategories.includes(topCategoryL1);
    const isSearch = get(searchBrowse, 'pageType') === SEARCH;

    if (
        get(user, 'isVerifiedTrade') &&
        !getSourcingRequestSubmitted() &&
        isValidCategory &&
        isSearch
    ) {
        return (
            <React.Suspense fallback="">
                <SbRespTradeSourcingBannerLazy />
            </React.Suspense>
        );
    }

    return null;
}

SbRespTradeSourcingBannerComponent.propTypes = {
    searchBrowse: PropTypes.object,
    user: PropTypes.object,
};

export const SbRespTradeSourcingBanner = createFragmentContainer(
    SbRespTradeSourcingBannerComponent,
    {
        searchBrowse: graphql`
            fragment SbRespTradeSourcingBanner_searchBrowse on SearchBrowseQueryConnection {
                pageType
                topCategoryL1
            }
        `,
        user: graphql`
            fragment SbRespTradeSourcingBanner_user on User {
                isVerifiedTrade
            }
        `,
    }
);
